import { render, staticRenderFns } from "./SetNested.vue?vue&type=template&id=06b8b13f"
import script from "./SetNested.vue?vue&type=script&lang=js"
export * from "./SetNested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports